import { motion } from "framer-motion";
import { Compass, PenTool, BedDouble, Car, Headphones } from "lucide-react";
import { DIFFERENTIATORS, MARQUEE_ITEMS } from "@/data/content";

const ICONS = { Compass, PenTool, BedDouble, Car, Headphones };

export const Differentiators = () => {
  return (
    <section
      data-testid="difference-section"
      id="difference"
      className="relative bg-[#f4ecdd]"
    >
      {/* Editorial marquee ribbon */}
      <div className="border-y border-[#b8965a]/25 py-6 overflow-hidden bg-[#efe4d1]">
        <div className="flex whitespace-nowrap animate-marquee">
          {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map(
            (item, i) => (
              <span
                key={i}
                className="font-serif-lux italic text-2xl md:text-3xl text-[#1f3a2e] mx-8 flex items-center gap-8"
              >
                {item}
                <span className="text-[#b8965a] not-italic text-lg">✦</span>
              </span>
            )
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="max-w-2xl mb-16">
          <p className="font-body-lux text-xs uppercase tracking-[0.35em] text-[#9c7d44] mb-8">
            Why Roam Around UAE
          </p>
          <h2 className="font-serif-lux font-light leading-[1.1] tracking-tight text-[#1f3a2e] text-4xl sm:text-5xl">
            The difference is in the design.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#b8965a]/20 border border-[#b8965a]/20">
          {DIFFERENTIATORS.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <motion.div
                key={item.title}
                data-testid={`difference-card-${i}`}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="group bg-[#faf6ef] p-10 md:p-12 hover:bg-[#fdfbf7] transition-colors duration-300"
              >
                <Icon
                  size={30}
                  strokeWidth={1.2}
                  className="text-[#b8965a] mb-8 group-hover:scale-110 transition-transform duration-300"
                />
                <h3 className="font-serif-lux text-2xl text-[#1f3a2e] mb-4">
                  {item.title}
                </h3>
                <p className="font-body-lux text-sm font-light text-[#47564d] leading-relaxed">
                  {item.body}
                </p>
              </motion.div>
            );
          })}

          {/* Filler CTA cell */}
          <motion.div
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="bg-[#1f3a2e] p-10 md:p-12 flex flex-col justify-between"
          >
            <h3 className="font-serif-lux text-3xl text-[#fdfbf7] leading-tight">
              Let&apos;s design your perfect UAE holiday.
            </h3>
            <button
              data-testid="difference-cta-btn"
              onClick={() =>
                document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })
              }
              className="font-body-lux text-sm tracking-wide text-[#b8965a] mt-8 self-start border-b border-[#b8965a] pb-1 hover:pb-2 transition-all duration-300"
            >
              Begin the conversation →
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
